module.exports = __webpack_public_path__ + "static/media/graduate.108175ce.png";